import Divider from 'LuxKit/Divider'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import RadioButton from 'LuxKit/Radio/RadioButton'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { SelectedTrip } from './TripPlannerToggle'
import { BasicTrip } from 'tripPlanner/types/common'
import { TRIP_PLANNER_ALL_TRIPS_OPTION, TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION } from '../SearchResultsMap'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import noop from 'lib/function/noop'

interface Props {
  trips: Array<BasicTrip>
  selectedTrip: SelectedTrip
  handleSelectTrip?: (tripName: string, tripId?: string) => void
}

function TripList({ trips, selectedTrip, handleSelectTrip = noop }: Props) {
  const modalElement = useModalElementContext()
  const intl = useIntl()

  const showAllTripsText = intl.formatMessage({
    id: 'rVTFT/NfUt',
    defaultMessage: 'Show all trips',
    description: 'List item title to show all saved trips on the map',
  })

  const hideAllTripsText = intl.formatMessage({
    id: 'FcQKJA8L8V',
    defaultMessage: 'Hide all trips',
    description: 'List item title to hide all saved trips from the map',
  })

  const handleSelectAllTrips = useCallback(() => {
    handleSelectTrip(TRIP_PLANNER_ALL_TRIPS_OPTION)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  const handleHideAllTrips = useCallback(() => {
    handleSelectTrip(TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  const selectTrip = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const tripId = e.currentTarget.dataset.tripId
    const tripName = e.currentTarget.dataset.tripName!
    handleSelectTrip(tripName, tripId)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  return (
    <>
      <ClickableListItem
        title={showAllTripsText}
        selected={selectedTrip.name === TRIP_PLANNER_ALL_TRIPS_OPTION && !selectedTrip.tripId}
        onClick={handleSelectAllTrips}
        endIcon={<RadioButton checked={selectedTrip.name === TRIP_PLANNER_ALL_TRIPS_OPTION && !selectedTrip.tripId} />}
      />
      <ClickableListItem
        title={hideAllTripsText}
        selected={selectedTrip.name === TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION && !selectedTrip.tripId}
        onClick={handleHideAllTrips}
        endIcon={<RadioButton checked={selectedTrip.name === TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION && !selectedTrip.tripId} />}
      />
      <Divider kind="primary" />
      {
        trips.map((trip) => {
          return (
            <ClickableListItem
              key={trip.id}
              title={trip.name}
              selected={selectedTrip.tripId === trip.id}
              data-trip-name={trip.name}
              data-trip-id={trip.id}
              onClick={selectTrip}
              endIcon={<RadioButton checked={selectedTrip.tripId === trip.id} />}
            />
          )
        })
      }
    </>
  )
}

export default TripList
